import { component_tool } from '@/tool'
const { WizLocationSelect } = component_tool

let componentName = 'classroom'

const columns = [
  {
    title: '教室名称',
    name: 'name',
    dataIndex: 'name',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '教室编号',
    name: 'code',
    dataIndex: 'code',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '培训中心',
    name: 'trainCenterId',
    dataIndex: 'trainCenterId',
    dict: {
      wizReplaceData: 'trainCenterList',
      defalutType: []
    },
    searchItem: {
      type: 'select'
    },
    tableItem: {}
  },
  {
    title: '城市',
    name: 'city',
    dataIndex: 'city',
    searchItem: {
      type: 'diy',
      diy: WizLocationSelect,
      showSearch: true
    },
    tableItem: {}
  },
  {
    title: '教室类型',
    name: 'type',
    dataIndex: 'type',
    dict: [
      { code: 0, codeName: '普通教室' },
      { code: 1, codeName: '进车' },
      { code: 2, codeName: '模拟展厅' },
      { code: 3, codeName: '技术银级认证教室' },
      { code: 4, codeName: '技术铜级认证教室' },
      { code: 5, codeName: '技术IBT教室' },
      { code: 6, codeName: '技术ILT实操教室' },
      { code: 7, codeName: '培训教室' },
      { code: 8, codeName: '电脑教室' },
      { code: 9, codeName: '多功能教室' },
      { code: 10, codeName: '二手车培训教室' },
      { code: 11, codeName: '技术培训教室' },
      { code: 12, codeName: '绕车演练场地' },
      { code: 13, codeName: '技术实操教室' },
      { code: 14, codeName: '多功能培训教室' },
      { code: 15, codeName: '多功能会议室' }
    ],
    tableItem: {}
  },
  {
    title: '教室用途',
    name: 'purpose',
    dataIndex: 'purpose',
    dict: [
      { code: 0, codeName: '不限制' },
      { code: 1, codeName: '新产品培训' },
      { code: 2, codeName: '实操培训' },
      { code: 3, codeName: '岗位培训' },
      { code: 4, codeName: '区域会议' }
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {}
  },
  {
    title: '教室状态',
    name: 'status',
    dataIndex: 'status',
    dict: [
      { code: 0, codeName: '正常' },
      { code: 1, codeName: '停止使用' },
      { code: 2, codeName: '维修中' }
    ],
    searchItem: {
      type: 'select'
    }
  },
  {
    title: '进车(数量)',
    name: 'parkingSpace',
    dataIndex: 'parkingSpace',
    tableItem: {}
  },
  {
    title: '座位(数量)',
    name: 'seat',
    dataIndex: 'seat',
    tableItem: {}
  },
  {
    title: '教室面积㎡',
    name: 'floorSpace',
    dataIndex: 'floorSpace',
    tableItem: {}
  },
  {
    title: '教室管理员',
    name: 'personInfoList',
    tableItem: {
      width: 200,
      render: (personInfoList) => {
        let result = []
        if (personInfoList && personInfoList.length) {
          personInfoList.forEach(personInfo => {
            personInfo.fullName && result.push(personInfo.fullName)
          })
        }
        return result.toString()
      }
    }
  },
  {
    title: '审核类型',
    name: 'auditType',
    dataIndex: 'auditType',
    dict: [
      { code: 0, codeName: '自动审核' },
      { code: 1, codeName: '手动审核' }
    ],
    tableItem: {}
  },
  {
    title: '教室状态',
    name: 'status',
    dataIndex: 'status',
    dict: [
      { code: 0, codeName: '正常' },
      { code: 1, codeName: '停止使用' },
      { code: 2, codeName: '维修中' }
    ],
    tableItem: {}
  }
]

const templateConfig = {
  mainProps: {},
  content: {
    name: 'WizTableList',
    params: {
      columns,
      searchBarProps: {
        buttonSort: ['add', 'delete', 'export'],
        buttons: [
          {
            key: 'add',
            custom: true,
            params: { children: '新增', icon: 'plus', type: 'primary' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/face/classroom/classroomAdd'
              }
            }
          },
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出组织', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'export',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return { ...filters }
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: 'id',
        selectType: 'checkbox',
        isScroll: true,
        loading: false
      },
      rowOperateSort: ['update'],
      rowOperateView: [
        {
          key: 'update',
          custom: true,
          params: { children: '编辑'},
          customOnClick: {
            key: 'jumpPage',
            params: {
              key: 'push',
              pathname: '/face/classroom/classroomUpd'
            }
          }
        }
      ]
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  },
  trainCenterList: {
    path: 'trainCenter/info',
    payload: {
      key: `${componentName}@trainCenterList`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enableOrganization`,
    payload: {
      key: `${componentName}@enableOrganization`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list', 'trainCenterList'],
    needLoading: true,
    ...args
  }
}

export { reduxTemplateCofig, templateConfig }
